import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg, money } from "@/lib/api";

export const AnnulationDialog = ({ r, onClose, onDone }) => {
  const [pct, setPct] = useState("50");
  const [penalite, setPenalite] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => { if (r) { setPct(String(r.penalite_annulation ?? r.annulation_pct ?? 50)); setPenalite(!!(r.penalite_annulation || r.annulation_probable)); } }, [r]);
  const envoyer = async (annulee) => {
    setLoading(true);
    try { await api.put(`/reservations/${r.id}/annulation`, { annulee, pct: Number(pct) || 0, penalite }); toast.success(annulee ? "Réservation marquée annulée" : "Annulation retirée"); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setLoading(false); }
  };
  const loyer = r ? (r.loyer_initial ?? r.loyer) : 0;
  return (
    <Dialog open={!!r} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="annulation-dialog">
        <DialogHeader>
          <DialogTitle>Réservation {r?.code} annulée par le voyageur</DialogTitle>
          <DialogDescription>La plateforme verse un pourcentage du loyer, sans TPS ni TVQ. À 0 %, la réservation ne figure plus dans les « réservations sans dépôt ».</DialogDescription>
        </DialogHeader>
        <div className="space-y-1">
          <Label>Pourcentage du loyer versé</Label>
          <Input type="number" min="0" max="100" step="1" value={pct} onChange={(e) => setPct(e.target.value)} data-testid="annulation-pct-input" />
          <p className="text-xs text-slate-500" data-testid="annulation-attendu">{penalite ? `Montants importés conservés : ${money(r?.total_verse ?? 0)} versés` : `Versement attendu : ${money(loyer * (Number(pct) || 0) / 100)} (loyer ${money(loyer)})`}</p>
          <label className="mt-2 flex items-start gap-2 text-xs text-slate-700">
            <input type="checkbox" className="mt-0.5" checked={penalite} onChange={(e) => setPenalite(e.target.checked)} data-testid="annulation-penalite-checkbox" />
            Les montants importés sont déjà réduits par la plateforme (pénalité déjà appliquée, ex. Airbnb 50 %)
          </label>
        </div>
        <DialogFooter className="gap-2">
          {(r?.annulee || r?.penalite_annulation) && <Button variant="outline" onClick={() => envoyer(false)} disabled={loading} data-testid="annulation-retirer">Retirer l'annulation</Button>}
          <Button onClick={() => envoyer(true)} disabled={loading} className="bg-emerald-700 hover:bg-emerald-800" data-testid="annulation-confirmer">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Enregistrer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
